/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";
import Modal from "./ViewComponents/ViewComponentsNav/Modal";
import ModalFull from "./ViewComponents/ViewComponentsNav/ModalFull";

import ViewCredito from "./ViewComponents/View_Credito";
import ViewCompartilhar from "./ViewComponents/View_Compartilhar";

// Componentes de roteamento
import { Route, Navigate, useNavigate } from 'react-router-dom'
import logo from "./../Assets/logonav.svg";
/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */



 class Nav extends React.Component {

    constructor(props) {
        super(props)
    }

    logout() {
      this.props.auth.auth.signOut()
      console.log("deslogar");
      this.props.navigate('/login')
    }

  Tela_Home() {
    return (
      <div className="text-center">
        <h4 className="mb-5">
          Tem certeza que desaja volta a página inicial?
          <br /> Você perderá seu progresso no jogo.
        </h4>
        
          <button
            type="button"
            className="button-custom inicial bg-white arround-25"
            data-bs-dismiss="modal"
            onClick={() => this.props.navigate('/')}
          >
            <span className="material-icons-outlined md-44 align-middle">
              home
            </span>
            INICIO
          </button>
      </div>
    );
  }
  
  Tela_modo() {
    return (
      <div className="text-center">
        <h4 className="mb-5">
          Tem certeza que desaja volta a escolha de temas?
          <br /> Você perderá seu progresso no jogo.
        </h4>

        <button
          type="button"
          className="button-custom inicial bg-white arround-25"
          data-bs-dismiss="modal"
          onClick={() => this.props.navigate('/modo')}
        >
          <span className="material-icons-outlined md-44 align-middle">
            dashboard
          </span>
          TEMAS
        </button>
      </div>
    );
  }

  Tela_sair() {
    return (
      <div className="text-center">
        <h4 className="mb-5">
          Tem certeza que desaja sair do perfil?
          <br /> Você perderá seu progresso no jogo.
        </h4>

        <button
          type="button"
          className="button-custom inicial bg-white arround-25"
          data-bs-dismiss="modal"
          onClick={() => this.logout()}
        >
          <span className="material-icons-outlined md-44 align-middle">
            logout
          </span>
          SAIR
        </button>
      </div>
    );
  }
  render() {

    // ROTEAMENTO - colocar controle de estados da aplicação
    return (
      <div>
        <div className="d-flex nav-main bg-white1 align-items-center">
          <img className="logonav mx-3 my-md-4" src={logo} alt="logo EIC" />
          <i
            className=" flex material-icons md-grey md-36  mx-2 my-md-3"
            data-bs-toggle="modal"
            data-bs-target="#modal-home"
          >
            home
          </i>
          <i
            className=" flex material-icons md-grey md-36  mx-2 my-md-3"
            data-bs-toggle="modal"
            data-bs-target="#modal-modo"
            alt="ir para Temas"
          >
            dashboard
          </i>
          <i
            className=" flex material-icons md-grey md-36  mx-2 my-md-3"
            data-bs-toggle="modal"
            data-bs-target="#modal-shared"
          >
            share
          </i>
          <i
            className=" flex material-icons md-grey md-36  mx-2 my-md-3"
            data-bs-toggle="modal"
            data-bs-target="#modal-groups"
          >
            groups
          </i>

          <i
            className=" flex material-icons md-grey md-36  mx-2 my-md-3"
            data-bs-toggle="modal"
            data-bs-target="#modal-logout"
          >
            logout
          </i>
        </div>

        <Modal vinculo="modal-home" titulo="Atenção">
          {this.Tela_Home()}
        </Modal>

        <Modal vinculo="modal-modo" titulo="Atenção">
          { this.Tela_modo()}
        </Modal>
        <ModalFull vinculo="modal-shared">
          <div className="view1">
            <ViewCompartilhar className="flex-fill" back={null} />
          </div>
        </ModalFull>
        <ModalFull vinculo="modal-groups">
          <div className="view">
            <ViewCredito className="flex-fill" back={null} />
          </div>
        </ModalFull>
        <ModalFull vinculo="modal-groups">
          <ViewCredito className="flex-fill" back={null} />
        </ModalFull>
        <Modal vinculo="modal-logout" titulo="Sair">
          {this.Tela_sair()}
        </Modal>
      </div>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <Nav {...props} navigate={navigate} />
}

export default WithNavigate